import React, { useState } from "react";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Header from "../Components/Header";
import GetTokenController from "../../Controller/GetTokenController";

const LoginView = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loginAttempt, setLoginAttempt] = useState(false);

    const handleLogin = (event) => {
        event.preventDefault();
        setLoginAttempt(true); // This triggers the token fetching
    };

    return (
        <>
            <Header title="Connexion" />
            <h1 className='text-white text-center mb-5'>Connexion</h1>
            <Form className='text-white' onSubmit={handleLogin}>
                <Form.Group className="mb-3" controlId="formBasicUsername">
                    <Form.Label>Username</Form.Label>
                    <Form.Control
                        className='mb-5'
                        type="text"
                        placeholder="Votre username"
                        onChange={(e) => setUsername(e.target.value)}
                        required
                    />
                </Form.Group>

                <Form.Group className="mb-5" controlId="formBasicPassword">
                    <Form.Label>Mot de passe</Form.Label>
                    <Form.Control
                        type="password"
                        placeholder="Votre mot de passe"
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                </Form.Group>
                <div className='text-center mt-5 mb-3'>
                    <Button className='mb-4' size="lg" variant="secondary" type="submit">
                        Se connecter
                    </Button>
                </div>
            </Form>
            {loginAttempt && <GetTokenController username={username} password={password} />}
        </>
    );
};

export default LoginView;